/* eslint-disable react/prop-types */
import React from 'react'

import ButtonBase from '@mui/material/ButtonBase'
import ConvertTo from '../icons/ConvertTo'

export const ConvertToIcon = () => (
  <ButtonBase>
    <ConvertTo />
  </ButtonBase>
)
